class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.setHeaderCartIconAccessibilityFooter();
    this.setHeaderDrawerCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  setHeaderCartIconAccessibilityFooter() {
    const cartLink = document.querySelector('#cart-icon-bubble2');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  setHeaderDrawerCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble3');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      // Close the menu drawer first if open
      const menuDrawer = document.querySelector('header-drawer');
      if (menuDrawer) {
        const menuDetails = menuDrawer.querySelector('details');
        if (menuDetails && menuDetails.hasAttribute('open')) {
          menuDetails.removeAttribute('open');
        }
      }
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }
  
  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

     // Also update footer cart icon if cart-icon-bubble2 section wasn't returned
    this.updateFooterCartIcon(parsedState);

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
    if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      console.log('PUB_SUB_EVENTS', PUB_SUB_EVENTS);
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-drawer', cartData: parsedState });
    }
  }

  updateFooterCartIcon(parsedState) {
    const footerCartIcon = document.querySelector('#cart-icon-bubble2');
    const drawerCartIcon = document.querySelector('#cart-icon-bubble3');
    
    if ((!footerCartIcon && !drawerCartIcon) || !parsedState.sections || !parsedState.sections['cart-icon-bubble']) return;

    try {
      // Use the same method as header cart icon to extract content
      const cartIconContent = this.getSectionInnerHTML(
        parsedState.sections['cart-icon-bubble'],
        '.shopify-section'
      );
      
      // Update footer cart icon
      if (footerCartIcon) {
        footerCartIcon.innerHTML = cartIconContent;
        this.setHeaderCartIconAccessibilityFooter();
      }
      
      // Update header drawer cart icon
      if (drawerCartIcon) {
        drawerCartIcon.innerHTML = cartIconContent;
        this.setHeaderDrawerCartIconAccessibility();
      }
    } catch (e) {
      console.error('Error updating cart icons:', e);
    }
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      }
    ];
  }

  getSectionInnerHTML(html, selector) {
    const innerHTML = super.getSectionInnerHTML(html, selector);
    // Also update footer cart icon when processing cart-icon-bubble section
    if (html.includes('cart-icon-bubble') || html.includes('shopify-section-cart-icon-bubble')) {
      this.updateFooterCartIcon(html);
    }
    return innerHTML;
  }

   updateFooterCartIcon(html) {
    try {
      const cartIconDoc = new DOMParser().parseFromString(html, 'text/html');
      const cartIconBubbleSection = cartIconDoc.querySelector('#shopify-section-cart-icon-bubble');
      const footerCartIcon = document.querySelector('#cart-icon-bubble2');
      const drawerCartIcon = document.querySelector('#cart-icon-bubble3');
      
      if (!cartIconBubbleSection) return;
      
      const cartIconContent = cartIconBubbleSection.innerHTML;
      
      // Update footer cart icon
      if (footerCartIcon) {
        footerCartIcon.innerHTML = cartIconContent;
      }
      
      // Update header drawer cart icon
      if (drawerCartIcon) {
        drawerCartIcon.innerHTML = cartIconContent;
      }
      
      // Re-attach event listeners after update
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        if (typeof cartDrawer.setHeaderCartIconAccessibilityFooter === 'function') {
          cartDrawer.setHeaderCartIconAccessibilityFooter();
        }
        if (typeof cartDrawer.setHeaderDrawerCartIconAccessibility === 'function') {
          cartDrawer.setHeaderDrawerCartIconAccessibility();
        }
      }
    } catch (e) {
      console.error('Error updating cart icons:', e);
    }
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);


window.updateMenuDrawerCartImages = function (cartData) {
  const container = document.getElementById('menu-drawer-cart-images');
  if (!container) return;

  const items = cartData && Array.isArray(cartData.items) ? cartData.items : [];

  if (!items.length) {
    container.innerHTML = '';
    return;
  }

  const list = document.createElement('ul');
  list.className = 'menu-drawer__cart-image-list';

  items.forEach((item) => {
    const li = document.createElement('li');
    li.className = 'menu-drawer__cart-image-item';

    const link = document.createElement('a');
    link.className = 'menu-drawer__cart-image-link';
    link.href = item.url || (item.handle ? `/products/${item.handle}` : '#');

    const imageData = item.image || item.featured_image;
    // const imageUrl = imageData && (imageData.url || imageData.src);

   const imageUrl = item.image;

    // console.log('item', item);
    if (imageUrl) {
      const img = document.createElement('img');
      img.className = 'menu-drawer__cart-image';
      img.src = imageUrl;
      img.loading = 'lazy';
      img.alt = item.product_title || item.title || '';
      link.appendChild(img);
    } else {
      const placeholder = document.createElement('div');
      placeholder.className = 'menu-drawer__cart-image-placeholder';
      placeholder.textContent = item.product_title || item.title || '';
      link.appendChild(placeholder);
    }

    li.appendChild(link);
    list.appendChild(li);
  });

  container.innerHTML = '';
  container.appendChild(list);
};

window.refreshMenuDrawerCartImages = function () {
  const hasContainer = document.getElementById('menu-drawer-cart-images');
  if (!hasContainer) return;

  if (window.cart && Array.isArray(window.cart.items)) {
    window.updateMenuDrawerCartImages(window.cart);
    return;
  }

  if (typeof routes !== 'undefined' && routes.cart_url) {
    fetch(`${routes.cart_url}.js`)
      .then((response) => response.json())
      .then((cart) => {
        window.updateMenuDrawerCartImages(cart);
      })
      .catch(() => {});
  }
};

if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    if (!event || !event.cartData) return;
    window.updateMenuDrawerCartImages(event.cartData);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const hasContainer = document.getElementById('menu-drawer-cart-images');
  if (!hasContainer) return;

  if (window.cart && Array.isArray(window.cart.items)) {
    window.updateMenuDrawerCartImages(window.cart);
    return;
  }

  if (typeof routes !== 'undefined' && routes.cart_url) {
    fetch(`${routes.cart_url}.js`)
      .then((response) => response.json())
      .then((cart) => {
        window.updateMenuDrawerCartImages(cart);
      })
      .catch(() => {});
  }
});